import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { COMMON_API } from '../../CommonAPI';

const ConnectUs = () => {
    const [connectInfo, setConnectInfo] = useState([]);

    useEffect(() => {
        const fetchConnectUs = async () => {
            try {
                const token = sessionStorage.getItem("authToken");
                const res = await axios.get(`${COMMON_API}/api/connectus/get-connectus`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setConnectInfo(res.data.data || []);
            } catch (error) {
                toast.error("Error fetching contact info");
            }
        };
        fetchConnectUs();
    }, []);

    return (
        <div className="ml-64 p-8 bg-gray-100 min-h-screen">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-3xl font-semibold text-gray-800">Contact Info</h2>
            </div>
            <div className="overflow-x-auto bg-white rounded shadow">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">S.No</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Email</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Phone</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">FB</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Instagram</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Twitter</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">LinkedIn</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {connectInfo.map((info, index) => (
                            <tr key={info.id}>
                                <td className="px-6 py-4">{index + 1}</td>
                                <td className="px-6 py-4">{info.email}</td>
                                <td className="px-6 py-4">{info.phoneno}</td>
                                <td className="px-6 py-4">{info.fb_link}</td>
                                <td className="px-6 py-4">{info.insta_link}</td>
                                <td className="px-6 py-4">{info.twitter_link}</td>
                                <td className="px-6 py-4">{info.linked_in_link}</td>
                                <td className="px-6 py-4">
                                    <Link
                                        to={`/edit_connectus/${info.id}`}
                                        className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1 rounded"
                                    >
                                        Edit
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ConnectUs;
